export class InspepctionFormModel {
    public id?: string | null = null;
    public title?: string | null = null;
    public description?: string | null = null;
    public appliedOnProtectionTechnquesGas?: Array<string> = [];
    public appliedOnProtectionTechnquesDust?: Array<string> = [];

    constructor(data?: Partial<InspepctionFormModel>) {
        Object.assign(this, data);
    }
}
